export default {
  namespaced: true,
  state: {
    servidor: null,
  },
  getters: {
    getServidor(state) {
      return state.servidor;
    },
  },
  mutations: {
    setServidor(state, payload) {
      state.servidor = payload;
    },
  },
  actions: {},
};
